import React from 'react';
import { MessageCircle } from 'lucide-react';

const slug = (title) => title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export const ConsultationCard = ({ service, onBook }) => (
  <div
    className="bg-black/60 border border-[#D4AF37]/20 rounded-2xl p-6 hover:border-[#D4AF37]/40 transition-colors duration-200 group relative overflow-hidden"
    data-testid={`consultation-card-${slug(service.title)}`}
  >
    {service.badge && (
      <div className="absolute top-3 right-3 bg-gradient-to-r from-[#D4AF37] to-[#AA8022] text-black text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">
        {service.badge}
      </div>
    )}

    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#D4AF37]/20 to-[#FF9933]/10 flex items-center justify-center mb-5">
      <service.icon className="w-7 h-7 text-[#D4AF37]" />
    </div>

    <h3 className="text-xl font-medium text-white font-['Cormorant_Garamond'] mb-1">
      {service.title}
    </h3>
    <p className="text-[#A89B8C] text-xs uppercase tracking-[0.15em] mb-4">
      {service.duration}
    </p>

    <div className="text-3xl font-medium text-[#D4AF37] mb-4 font-['Cormorant_Garamond']">
      ₹{service.price}
    </div>

    <p className="text-[#A89B8C] text-sm leading-relaxed mb-4">{service.description}</p>

    <ul className="space-y-2 mb-6">
      {service.features.map((f) => (
        <li key={f} className="flex items-center gap-2 text-[#E8DCC4] text-xs">
          <span className="w-1 h-1 rounded-full bg-[#D4AF37]" />
          {f}
        </li>
      ))}
    </ul>

    <button
      type="button"
      onClick={() => onBook(service.whatsappMessage)}
      data-testid={`consultation-book-${slug(service.title)}`}
      className="w-full bg-gradient-to-r from-[#F3E5AB] via-[#D4AF37] to-[#AA8022] text-black font-semibold text-sm py-3 rounded-full flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transition-shadow duration-200"
    >
      <MessageCircle className="w-4 h-4" />
      Book Now
    </button>
  </div>
);
